import {
  StorageItemsPaginationMetaFragment,
  StorageItemFragment,
  GetStorageItemsDocument,
  GetStorageItemsQuery,
  GetStorageItemsQueryVariables,
} from '@sketch/gql-types'
import {
  removeFromPaginated,
  errorPreventiveCacheRead,
} from '../../utils/apolloCache'
import { ClientOrCache } from '@sketch/graphql-cache'

export interface RemoveFromStorageItemsListProps {
  cache: ClientOrCache
  target: Pick<StorageItemFragment, '__typename' | 'identifier'>
  filter?: (key: string) => boolean
}

export function removeFromStorageItemsList(
  props: RemoveFromStorageItemsListProps
) {
  const { cache, target, filter }: typeof props = props

  removeFromPaginated(
    cache,
    target,
    key => key.includes('.storageItems') && (filter ? filter(key) : true),
    true,
    meta => {
      if (!meta) return

      const maybePagination = meta as StorageItemsPaginationMetaFragment
      const keys = Object.keys(maybePagination) as Array<
        keyof StorageItemsPaginationMetaFragment
      >

      if (
        target.__typename === 'Project' &&
        keys.includes('nestedProjectsCount')
      ) {
        maybePagination.nestedProjectsCount--
      }
      if (target.__typename === 'Share' && keys.includes('sharesCount')) {
        maybePagination.sharesCount--
      }
    }
  )
}

export function readStorageItems(
  cache: ClientOrCache,
  variables: GetStorageItemsQueryVariables
) {
  return errorPreventiveCacheRead<
    GetStorageItemsQuery,
    GetStorageItemsQueryVariables
  >(cache, {
    query: GetStorageItemsDocument,
    variables,
  })
}
